angular.module('moebiusProadapt').controller('filteredOnglet',
    ['$scope', '$rootScope', '$http', '$location', '$uibModal', 'promiseTracker', 'mbsEtiService', function ($scope, $rootScope, $http, $location, $uibModal, promiseTracker, mbsEtiService) {

        /**
         * *************************************************************************************************
         * ********************* Initialization
         * *************************************************************************************************
         */
        $scope.filteredQuestionnairesVisites = [];
        /**
         * setup the controller
         */
        var initialize = function () {
            // -- setup data from resolver
            console.log('filteredOnglet ', $scope.onglet);

            if ($scope.onglet.service_data) {
                $scope.filteredQuestionnairesVisites = mbsEtiService[$scope.onglet.service_data]($scope.participant);
            }
        }

        initialize();
    }
    ]
);


// WEBPACK FOOTER //
// ./resources/assets/js/controllers/etude/onglet/filteredOnglet.js